<template>
  <Row v-if="balance" class="px-5 py-5">
    <Col cols="12" md="6">
      <strong>Disponível:</strong>
      {{ formatCurrency(balance.available_amount) }}
    </Col>
    <Col cols="12" md="6">
      <strong>Aguardando liberação:</strong>
      {{ formatCurrency(balance.waiting_funds_amount) }}
    </Col>
    <Col cols="12" md="6">
      <strong>Transferido:</strong>
      {{ formatCurrency(balance.transferred_amount) }}
    </Col>
    <Col cols="12" md="6">
      <strong>Moeda:</strong> {{ balance.currency || 'BRL' }}
    </Col>
  </Row>
  <div v-else class="text-center py-6">
    Não foi possível carregar o saldo.
  </div>
</template>

<script>
import { Row, Col } from '@/components/vuetify';
import { formatCurrency } from '@/utils';

export default {
  name: 'AdminDistributorPagarmeBalanceTab',
  components: { Row, Col },
  props: {
    balance: {
      type: Object,
      default: null,
    },
  },
  methods: {
    formatCurrency,
  },
};
</script>
